var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconKy = function SvgIconKy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M24 12c0 6.627-5.373 12-12 12S0 18.627 0 12C0 12.003 12 .001 12 0c6.627 0 12 5.373 12 12"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#F0F0F0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.969 12H12v-.032zM12 6.26V0h-.002C5.371 0 0 5.373 0 12h6.26V8.474l3.526 3.525h2.182l.032-.032V9.786L8.474 6.26z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#6DA544",
    d: "M17.217 8.87a2.087 2.087 0 1 0 0-4.175 2.087 2.087 0 0 0 0 4.174"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#D80027"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.07 1.565a12.06 12.06 0 0 0-4.506 4.506V12h3.13V4.696H12v-3.13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.999 10.524 7.735 6.26H6.26L11.999 12zM20.869 6.26h-7.304v3.13h7.304z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M13.565 14.087v2.087h1.098a3.64 3.64 0 0 0 2.555 1.043c.994 0 1.895-.398 2.554-1.043h1.098v-2.087z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#338AF3",
    d: "M13.565 8.87V12c0 2.795 3.653 3.652 3.653 3.652S20.87 14.795 20.87 12V8.87z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#F3F3F3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.217 10.54c-.913 0-.913.835-1.826.835s-.913-.835-1.826-.835v1.461c.913 0 .913.835 1.826.835S16.304 12 17.217 12s.913.835 1.827.835S19.957 12 20.87 12v-1.46c-.913 0-.913.834-1.826.834-.914 0-.914-.835-1.827-.835M17.217 7.617c-.913 0-.913.834-1.826.834s-.913-.834-1.826-.834v1.46c.913 0 .913.835 1.826.835s.913-.834 1.826-.834.913.834 1.827.834.913-.834 1.826-.834V7.617c-.913 0-.913.834-1.826.834-.914 0-.914-.834-1.827-.834"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIconKy;